export default "/_next/static/images/812890b44c9806b25d86c6aef9b33e4b.jpg";